export default {
  statistics: {
    total_campaigns: 'Total Campaigns',
    todays_sent_messages: 'Todays Sent Messages',
    total_subscribers: 'Subscribers',
    average_click_rate: 'Average Click Rate',
  },
};
